// context/WorkInProgressContext.js
import React, { createContext, useContext } from 'react';

const WorkInProgressContext = createContext();

export const useWorkInProgress = () => {
    const context = useContext(WorkInProgressContext);
    if (!context) {
        throw new Error('useWorkInProgress must be used within WorkInProgressProvider');
    }
    return context;
};

export const WorkInProgressProvider = ({ children }) => {
    // CAMBIA QUESTO VALORE PER ATTIVARE/DISATTIVARE LA PAGINA WIP
    const isWorkInProgress = false;

    return (
        <WorkInProgressContext.Provider value={{ isWorkInProgress }}>
            {children}
        </WorkInProgressContext.Provider>
    );
};